import { Skeleton } from '@/components/ui/skeleton';

/**
 * Placeholder for a route decision that has not resolved yet — shown while a
 * guard or a redirect still waits for the answer that decides where the user
 * belongs (ESCLOUD-288).
 *
 * Deliberately a skeleton and not a spinner: what comes next is a page, not a
 * result, and the two bars are the shape of the page heading it replaces.
 */
export function RouteDecisionSkeleton() {
    return (
        <div className="flex h-full items-center justify-center">
            <div className="w-64 space-y-4">
                <Skeleton className="h-8 w-full" />
                <Skeleton className="h-4 w-3/4" />
            </div>
        </div>
    );
}
